/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label[_ngcontent-%COMP%]{display:block;cursor:pointer;margin:0;padding-top:.5rem;padding-bottom:.5rem}label[_ngcontent-%COMP%]:hover{color:var(--blue-400)}label[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-left:1rem}.btn-invite-add-repo[_ngcontent-%COMP%]{padding:0;color:var(--blue-400)}.btn-invite-add-repo[_ngcontent-%COMP%]:hover{color:#7fffd4}.hide-form[_ngcontent-%COMP%]{display:none!important}"];
export { styles as styles };
